module.exports = __webpack_public_path__ + "static/media/button-bg.c5d72cf8.png";